import { useFeature } from '@mafc/appshell';

const useDriverTips = () => {
  const value = useFeature('cart_driver_tip').value || { tips: [] };

  const areTipsConfigured = value.tips.length > 0;

  return { areTipsConfigured, driverTips: value.tips };
};

export default useDriverTips;
